import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink} from "react-router-dom"
import axios from 'axios'
import { connectNode } from '../../../../utils/global'
import { loadLocationWithMessage } from '../../../../actions/location'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import PostAddIcon from '@material-ui/icons/PostAdd'
import '../../../../styles/assets/css/admin/list1.css'
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline'
import Pagination from '../../../functions/pagination'
import { filter_patient_status } from '../variables/patient_1.js'
import Spinner from 'react-spinner-material'
import Graph1 from './graph1'
class AssmReport extends Component {
  constructor() {
      super();
      this.state = {
          dataItems: [], //exampleItems,
          pageOfItems: [],
          data_group: [],
          show_filter_status: 2,
          filter_patient_status: [
            {
              label: 'All status',
              value: 1,
            }, {
              label: 'Active',
              value: 2,
            }, {
              label: 'Active and medication management',
              value: 3,
            },
          ],
      }
      this.onChangePage = this.onChangePage.bind(this)
  }

  componentDidMount() {
    this.getDataList()
  }

  getDataList = () => {
    // Data Group 1 //
    axios({
      method: 'post',
      url: connectNode + 'admin/reports/monthly_assessments',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: { filter_selected: this.state.show_filter_status }
    })
    .then((result) => {
      this.setState({
        data_group: result['data'][0].value,
      })
    })
  }

  handleChange2 = (e, name) => {
    this.setState({
      [name]: e.target.value
    }, () => {
      this.getDataList()
    })
  }

  onChangePage(pageOfItems) {
    this.setState({ pageOfItems: pageOfItems })
  }

  getDataGroup1 = (data) => {
    var buff_week = 0
    var arr = []
    data.map(each => {
      if(each.num_week >= buff_week) {
        buff_week = each.num_week
        arr.push({
          fullname: each.fullname,
          cnt: each.cnt,
          start_date: this.convertDateFormat2(each.start_date),
          end_date: this.convertDateFormat2(each.end_date),
        })
      }
    })
    return arr
  }

  render() {
    return (<>
    <div className="row">
      <div className="small-12 medium-7 columns">&nbsp;</div>
      <div className="small-12 medium-5 columns space_bottom1">
        <FormControl variant="outlined" className="">
          <Select value={this.state.show_filter_status} variant="outlined" label=""
            onChange={(e) => this.handleChange2(e, 'show_filter_status')}
            value={this.state.show_filter_status} >
          {this.state.filter_patient_status.map(each =>
            <MenuItem key={'apt'+each.value} value={each.value}>{each.label}</MenuItem>
          )}
          </Select>
        </FormControl>
      </div>
    </div>
    <div className="row">
      {this.state.data_group.length > 0 &&
      <div className="small-12 columns">
      <table className="table_data1">
        <thead className="table_head">
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Status</th>
            <th>Start date</th>
            <th>Last 3 months</th>
            <th>Last 6 months</th>
            <th>Last 1 Year</th>
            <th>Last 1 Year Percentage</th>
            <th>Total</th>
            <th>Total Percentage</th>
          </tr>
        </thead>
      {this.state.data_group.map(each =>
        <tr>
          <td>{each.uid}</td>
          <td>{each.fullname}</td>
          <td>{each.p_status}</td>
          <td>{each.d_start}</td>
          <td>{each.count_3_months}</td>
          <td>{each.count_6_months}</td>
          <td>{each.count_1_year}</td>
          <td>{each.months_in_last_year > 0 && (Number(each.count_1_year/each.months_in_last_year)*100).toFixed(0)}
          {each.months_in_last_year == 0 && '0'}%</td>
          <td>{each.total_count}</td>
          <td>
          {((each.months_diff_discharge > 0) && ((Number(each.total_count/each.months_diff_discharge)*100).toFixed(0)))}
          {((!each.months_diff_discharge) && ((Number(each.total_count/each.months_diff_now)*100).toFixed(0)))}%
          </td>
        </tr>)}
      </table>
      </div>}
    </div>
    </>)}
}

const mapStateToProps = (state) => {
  //console.log('PatientList STATE: ', state)
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    //console.log('PatientList mapDispatchToProps')
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(AssmReport)
